import { useState } from 'react';
import { Link } from 'react-router-dom';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { AccountCardSmallTile, AccountCardSmallTileVcfc } from './small/card';
import { AccountPaymentSmallTile, AccountPaymentSmallTileVcfc } from './small/payment';

interface IAccountTileSmallProps {
  className?: string;
  account: AccountResponse;
  subAccounts?: AccountResponse[];
  isOrphanSub?: boolean;
  currency?: string;
}

export const AccountTileSmall = (props: IAccountTileSmallProps) => {
  const [isDragging, setIsDragging] = useState<boolean>(false);

  return (
    <>
      {props.account.type === AccountType.Payment && (
        <Link
          className={cn('transition-transform duration-200 hover:scale-[103%]', props.className)}
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => (e.preventDefault(), setIsDragging(true))}
          onMouseUp={() => setTimeout(() => setIsDragging(false), 0)}
          onMouseLeave={() => setTimeout(() => setIsDragging(false), 0)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          {PaletteUtils.isInsigniaPalette && (
            <AccountPaymentSmallTile
              accounts
              account={props.account}
              subAccounts={props.subAccounts!}
              isOrphanSub={props.isOrphanSub}
              currency={props.currency}
            />
          )}
          {PaletteUtils.isVcfcPalette && (
            <AccountPaymentSmallTileVcfc
              accounts
              account={props.account}
              subAccounts={props.subAccounts!}
              isOrphanSub={props.isOrphanSub}
              currency={props.currency}
            />
          )}
        </Link>
      )}
      {props.account.type === AccountType.Card && (
        <Link
          className={cn('transition-transform duration-200 hover:scale-[103%]', props.className)}
          to={RoutePaths.account.onNavigate(props.account.id)}
          onDragStart={(e) => (e.preventDefault(), setIsDragging(true))}
          onMouseUp={() => setTimeout(() => setIsDragging(false), 0)}
          onMouseLeave={() => setTimeout(() => setIsDragging(false), 0)}
          onClick={(e) => isDragging && e.preventDefault()}
        >
          {PaletteUtils.isInsigniaPalette && <AccountCardSmallTile account={props.account} />}
          {PaletteUtils.isVcfcPalette && <AccountCardSmallTileVcfc account={props.account} />}
        </Link>
      )}
    </>
  );
};
